module.exports = __webpack_public_path__ + "img/5.08.1ff98748.jpg";